import { render, staticRenderFns } from "./Expiration.vue?vue&type=template&id=47685b38"
import script from "./Expiration.vue?vue&type=script&lang=js"
export * from "./Expiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports